module.exports = __webpack_public_path__ + "static/c4-efb38901f9203af7a75c19074a941bf7.png";